import { Inject } from '@angular/core';
import '@angular/compiler';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { LayoutAuthoringComponent } from './layout.authoring/layout.authoring.component';
import { PageDatasetsComponent } from './page.datasets/page.datasets.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { ComponentDatasetInstructionsComponent } from './component.dataset.instructions/component.dataset.instructions.component';
import { PageDpoComponent } from './page.dpo/page.dpo.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageKnowledge_mapComponent } from './page.knowledge_map/page.knowledge_map.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { ComponentWorkspaceNavComponent } from './component.workspace.nav/component.workspace.nav.component';
import { PageSourcesComponent } from './page.sources/page.sources.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PageKnowledge_graphComponent } from './page.knowledge_graph/page.knowledge_graph.component';
import { PageAdminComponent } from './page.admin/page.admin.component';
import { ComponentAdminDpoComponent } from './component.admin.dpo/component.admin.dpo.component';
import { ComponentSourceUploadComponent } from './component.source.upload/component.source.upload.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { registerWorkspacePages } from './workspace-pages';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// WIZ injects the component imports and declaration list during its normal build.
const pageGroups: Record<string, any[]> = {
    'page.admin': [PageAdminComponent, ComponentAdminDpoComponent],
    'page.sources': [PageSourcesComponent, ComponentSourceUploadComponent],
    'page.datasets': [PageDatasetsComponent, ComponentDatasetInstructionsComponent],
    'page.dpo': [PageDpoComponent],
    'page.knowledge_graph': [PageKnowledge_graphComponent],
    'page.knowledge_map': [PageKnowledge_mapComponent]
};
const deferredDeclarations = new Set(Object.values(pageGroups).flat());
const wizDeclarations = [AppComponent,
        PortalSeasonFormDropdownComponent,
        PortalSeasonPaginationComponent,
        LayoutAuthoringComponent,
        PageDatasetsComponent,
        PortalSeasonLoadingDefaultComponent,
        ComponentDatasetInstructionsComponent,
        PageDpoComponent,
        PortalSeasonLoadingSeasonComponent,
        PageAccessComponent,
        PageKnowledge_mapComponent,
        PortalSeasonModalComponent,
        PortalSeasonTreeComponent,
        ComponentWorkspaceNavComponent,
        PageSourcesComponent,
        PageDashboardComponent,
        PageKnowledge_graphComponent,
        PageAdminComponent,
        ComponentAdminDpoComponent,
        ComponentSourceUploadComponent];
const sharedDeclarations = wizDeclarations.filter(component => component !== AppComponent && !deferredDeclarations.has(component));

@NgModule({
    declarations: [SafePipe, ...sharedDeclarations],
    imports: [CommonModule, FormsModule, RouterModule, TranslateModule, ],
    exports: [SafePipe, ...sharedDeclarations, CommonModule, FormsModule, RouterModule, TranslateModule]
})
class WorkspaceSharedModule {}

const pageModules = new Map<string, any>();
registerWorkspacePages((id, route) => {
    if (pageModules.has(id)) return pageModules.get(id);
    const declarations = pageGroups[id];
    if (!declarations) throw new Error('작업 화면을 찾지 못했습니다.');
    class WorkspacePageModule {}
    NgModule({
        declarations,
        imports: [WorkspaceSharedModule, RouterModule.forChild([route])]
    })(WorkspacePageModule);
    pageModules.set(id, WorkspacePageModule);
    return WorkspacePageModule;
});

// Keep only the shell, dashboard and account screens in the startup scope.
@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        WorkspaceSharedModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        })
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }